
import React from "react";
import { SectionTitle } from "@/components/SectionTitle";

interface WhyChooseUsReason {
  number: number;
  title: string;
  description: string;
}

interface WhyChooseUsSectionProps {
  title: string;
  subtitle: string;
  reasons: WhyChooseUsReason[];
}

export const WhyChooseUsSection: React.FC<WhyChooseUsSectionProps> = ({
  title,
  subtitle,
  reasons,
}) => {
  return (
    <section className="py-16 bg-dental-offwhite">
      <div className="container-custom">
        <SectionTitle
          title={title}
          subtitle={subtitle}
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-12">
          {reasons.map((reason, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold mb-4 flex items-center">
                <span className="w-8 h-8 rounded-full bg-dental-highlight flex items-center justify-center text-white mr-3">
                  {reason.number}
                </span>
                {reason.title}
              </h3>
              <p>{reason.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
